import { render, staticRenderFns } from "./main.vue?vue&type=template&id=c92f8cb8&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=c92f8cb8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92f8cb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c92f8cb8')) {
      api.createRecord('c92f8cb8', component.options)
    } else {
      api.reload('c92f8cb8', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=c92f8cb8&scoped=true", function () {
      api.rerender('c92f8cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/campaign/edit/main.vue"
export default component.exports